var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tags && _vm.tags.length)?_c('div',{staticClass:"content-card-tags"},_vm._l((_vm.tags),function(tag,i){return _c('div',{key:i,staticClass:"content-card-tag"},[_vm._v(" #"+_vm._s(tag)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }